import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import React, { Component } from 'react';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

type Props = {
    intl: IntlShape;
    openSendSellerMessageModal: Function;
    phoneNumber: string;
    sellerId: number;
    sellerName: string;
};

class BidLimitExceededMessage extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    showSendSellerMessageModal = () => {
        const { intl, openSendSellerMessageModal, sellerId, sellerName } = this.props;
        const { formatMessage } = intl;

        const messageDetails = {};
        const subject = formatMessage({
            id: 'bidLimitExceededMessage.subject',
        });

        openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject);
    };

    render() {
        const { phoneNumber, sellerName } = this.props;

        return (
            <FormattedMessage
                id="bidLimitExceededMessage.text"
                values={{
                    link: (
                        <ActionText onClick={this.showSendSellerMessageModal}>
                            <FormattedMessage id="bidLimitExceededMessage.linkText" />
                        </ActionText>
                    ),
                    sellerName,
                    sellerPhone: <StyledLink to={`tel:${phoneNumber}`}>{phoneNumber}</StyledLink>,
                }}
            />
        );
    }
}

export default injectIntl(BidLimitExceededMessage);

const StyledLink = styled(Link)`
    &&& {
        text-decoration: none;

        &:focus,
        &:hover {
            color: ${({ theme }) => theme.colors.blue100};
            text-decoration: none;
        }
    }
`;
